<template>
  <b-row>
    <b-col xl="3">
      <b-form-group>
        <b-form-select
            class="form-control form-control-solid"
            v-model="form.rule_1"
            :options="rules[1]"
            @change="ruleChange(1)"
        ></b-form-select>
      </b-form-group>
      <b-form-group v-if="form.rule_2_status">
        <b-form-select
            class="form-control form-control-solid"
            v-model="form.rule_2"
            :options="rules[2][form.rule_1]"
            @change="ruleChange(2)"
        ></b-form-select>
      </b-form-group>
      <b-form-group v-if="form.rule_3_status && form.form_type == 'option'">
        <b-form-select
            class="form-control form-control-solid"
            v-model="form.rule_3"
            :options="rules[3][form.rule_2]"
            @change="ruleChange(3)"
        ></b-form-select>
      </b-form-group>

      <b-form-group v-if="form.form_type == 'multiple'">
        <b-form-checkbox-group
            v-model="form.rule_3_multiple"
            :options="rules[3][form.rule_2]"
            name="flavour-2a"
            stacked
        ></b-form-checkbox-group>
      </b-form-group>

      <div class="text-center">
        <div class="separator separator-dashed separator-border-2"></div>
        <b-form-group class="mb-3 mt-3">
          <b-form-radio-group
              id="btn-radios-2"
              v-model="form.action"
              :options="actions"
              buttons
              button-variant="outline-secondary"
              size="sm"
              name="action"
          ></b-form-radio-group>
        </b-form-group>
        <div class="separator separator-dashed separator-border-2"></div>
        <b-button-group class="mb-3 mt-3" size="sm">
          <b-button variant="outline-secondary"><i class="fas fa-trash-alt"></i> Sil</b-button>
          <b-button variant="outline-secondary"><i class="fas fa-list-ol"></i> Adet</b-button>
          <b-button variant="outline-secondary" v-b-modal.id_upload><i class="fas fa-cloud-upload-alt"></i> Data Yükle</b-button>
        </b-button-group>
        <div class="separator separator-dashed separator-border-2 mb-3"></div>
        <b-button @click="ClearForm" size="sm" variant="danger" class="mr-2"><i class="fas fa-trash mr-2"></i> Temizle</b-button>
        <b-button @click="SubmitForm" size="sm" variant="primary"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
      </div>
      <div class="count-box">
        <div class="counter">
          <div class="separator separator-dashed separator-border-2 mb-3"></div>
          <b-row>
            <b-col xl="9"><strong>TOPLAM</strong></b-col>
            <b-col xl="3" class="qty"><strong>{{ counter }}</strong></b-col>
          </b-row>
          <div class="separator separator-dashed separator-border-2 mt-3"></div>
        </div>
      </div>
    </b-col>
    <b-col xl="9">
      <Diagram :field="field" :clear="clear"></Diagram>
    </b-col>
  </b-row>
</template>

<script>

import DashboardBox from "@/assets/components/DashboardBox";
import Diagram from "@/view/pages/profiling/Diagram";
import Swal from "sweetalert2";
export default {
  name: "Profiling",
  components: { DashboardBox, Diagram},
  data() {
    return {
      form : {
        rule_1 : null,
        rule_2 : null,
        rule_3 : null,
        rule_2_status : null,
        rule_3_status : null,
        action : null,
        action2 : null,
        form_type : null,
        rule_3_multiple : []
      },
      rules : {
        1 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'Eğitim'}, {value : 2, text : 'Hobi'},{value : 3, text : 'İletişim'}],
        2 : {
              1 : [{text: this.$t('general.select'), value: null },{value : 1, text : 'En son mezun olduğunuz eğitim kurumu'}, {value : 2, text : 'İlkokulunuzun Adı'}, {value : 3, text : 'Ortaokulunuzun Adı'}, {value : 4, text : 'Lisenizin Adı'}],
              2 : [{ text: this.$t('general.select'), value: null } , {value : 5, text : 'Hangi spor dallarıyla ilgileniyorsunuz?'}, {value : 6, text : 'Boş vakitlerinizde ne yaparsınız?'}],
              3 : [{ text: this.$t('general.select'), value: null } , {value : 7, text : 'Hangi gsm operatörünü kullanıyorsunuz?', select_type: 'option'}, {value : 8, text : 'İl', select_type : 'multiple'}, {value : 9, text : 'İlçe'}]
        },
        3 : {
          1 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'İlkokul'}, {value : 2, text : 'Ortaokul'}, {value : 3, text : 'Lise'}, {value : 4, text : 'Üniversite'}],
          2 : [{ text: this.$t('general.select'), value: null } , {value : 5, text : 'Menderes İlköğretim Okulu'}, {value : 6, text : 'Nene Hatun İlk Öğretim Okulu'}],
          3 : [{ text: this.$t('general.select'), value: null } , {value : 7, text : 'Menderes Ortaöğretim Okulu'}, {value : 8, text : 'Nene Hatun Orta Öğretim Okulu'}],
          4 : [{ text: this.$t('general.select'), value: null } , {value : 9, text : 'Menderes Lisesi'}, {value : 10, text : 'Nene Hatun Lisesi'}],
          5 : [{ text: this.$t('general.select'), value: null } , {value : 11, text : 'Futbol'}, {value : 12, text : 'Basketbol'}, {value : 13, text : 'Tenis'}, {value : 14, text : 'Koşu'}],
          6 : [{ text: this.$t('general.select'), value: null } , {value : 15, text : 'Kitap okurum'}, {value : 16, text : 'Gezerim'}, {value : 17, text : 'Oyun oynarım'},{value : 18, text : 'Ailemle vakit geçiririm'}],
          7 : [{ text: this.$t('general.select'), value: null } , {value : 19, text : 'Turkcell'}, {value : 20, text : 'Vodafone'}, {value : 21, text : 'Turktelekom'}],
          8 : [ {value : 22, text : 'İstanbul'},{value : 26, text : 'Ankara'},{value : 27, text : 'İzmir'},,{value : 28, text : 'Samsun'},,{value : 29, text : 'Gaziantep'},{value : 30, text : 'Balıkesir'}],
          9 : [{ text: this.$t('general.select'), value: null } , {value : 23, text : 'Bahçelievler'}, {value : 24, text : 'Beşiktaş'}, {value : 25, text : 'Sarıyer'}],
        }
      },
      actions : ['Ve', 'Veya', 'Grup Ve', 'Grup Veya'],
      field : null,
      group: false,
      new_group : false,
      first_rule : true,
      clear : false,
      counter : 0
    }
  },
  mounted() {

  },
  methods: {
    formValidation(){
      if (this.form.action === null){
        Swal.fire({
          title: "",
          text: "Eksik bilgi girdiniz. Lütfen kontrol ediniz.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          confirmButtonText: "Tamam"
        });
       return false;
      }
      if (this.form.rule_3 === null && this.form.rule_3_multiple === null){
        Swal.fire({
          title: "",
          text: "Eksik bilgi girdiniz. Lütfen kontrol ediniz.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          confirmButtonText: "Tamam"
        });
        return false;
      }
      return true;
    },
    ruleChange(level){
      if (level == 1){
        this.group = false;
        this.new_group = true;
        this.first_rule = true;
        this.form.rule_2_status = true;
        this.form.rule_2 = null;
        this.form.rule_3 = null;
        this.form.rule_3_status = null;

      }
      if (level == 2){
        this.group = false;
        this.new_group = true;
        this.first_rule = true;
        this.form.rule_3_status = true;
        this.form.rule_3 = null;

        let self = this;
        let rules = self.rules[2][this.form.rule_1];
        rules.forEach(function (item,index){
          if (item.value == self.form.rule_2){
            if (item.select_type){
              self.form.form_type = item.select_type;
            }else{
              self.form.form_type = 'option';
            }
          }
        });
      }
      if (level == 3){
        if (!this.first_rule) {
          this.new_group = false;
        }
      }
    },
    SubmitForm(){
      if (this.formValidation()){
        this.first_rule = false;

        if (this.form.action == 'Grup Ve' || this.form.action == 'Grup Veya') {
          this.group = true;
        }else{
          this.group = false;
        }

        if (this.first_rule == false && this.group == false) {

        }
        let answers = this.rules[2][this.form.rule_1];
        let self = this;

        answers.forEach(function (item,index){
          if (item.value == self.form.rule_2){

            let reply = "";
            (self.form.rule_3 === null) ? reply = self.form.rule_3_multiple : reply = self.form.rule_3;

            self.field = {
              answer : item.text,
              reply : reply,
              type : self.form.action,
              group : self.group,
              new_group : self.new_group,
              option_type : self.form.form_type
            };
          }
        });

        this.counter = Math.floor(Math.random() * (10000 - 1 + 1)) + 1;
      }
    },
    ClearForm(){
      this.clear = true;
      this.form.rule_1 = null;
      this.form.rule_2 = null;
      this.form.rule_2_status = null;
      this.form.rule_3 = null;
      this.form.rule_3_status = null;
      this.form.action = null;
      this.$forceUpdate();

    }
  },
}
</script>

<style scoped>
.count-box{
}
.counter {
  width: 100%;
  position:absolute;
  bottom:0;
  padding-right: 30px;
}
.counter .qty{
  text-align: right;
}

</style>
